import { sprintf } from "sprintf-js"

const cipherTable = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"

export function decodeBoatClass ( code: string ): number {

    if ( !isNaN( Number( code ) ) )
        return parseInt( code )

    if ( code.length < 2 )
        code = sprintf( "%02s", code )

    const chars = Array.from( code );

    return 1000 + cipherTable.indexOf( chars[ 0 ] ) * 100 + cipherTable.indexOf( chars[ 1 ] )
}

export function encodeBoatClass ( code: number ): string {
    if ( code < 1000 )
        return sprintf( "%02d", code )

    code -= 1000

    let first = Math.trunc( code / 100 )
    let second = code % 100

    return cipherTable.charAt( first ) + cipherTable.charAt( second )
}